/**
 * `Object.keys`, typed to the object's own keys. Only for literal option maps, which carry no
 * inherited or extra keys. Exporting a component's options this way means the list is the map the
 * component styles from, so the two cannot drift.
 */
export function keysOf<T extends object>(obj: T): Array<keyof T & string> {
  return Object.keys(obj) as Array<keyof T & string>
}
